import { defineComponent } from "vue";
import useRoomInfo from "../RoomHeader/RoomInfo/useRoomInfoHooks.mjs";
import copyIcon from "../common/icons/CopyIcon.vue.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import { isMobile } from "../../utils/environment.mjs";
import { TUIConferenceStatus } from "@tencentcloud/tuiroom-engine-js";
import { useI18n } from "../../locales/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ConferenceDetail",
  props: {
    conferenceInfo: null,
    scheduleRoomDetailList: null
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const statusMap = {
      [TUIConferenceStatus.kConferenceStatusRunning]: {
        text: "Ongoing",
        className: "status-running"
      }
    };
    const { onCopy } = useRoomInfo();
    const getStatusTextAndClass = (status) => {
      if (!status) return { text: "", className: "" };
      return statusMap[status] || { text: "", className: "" };
    };
    return { __sfc: true, t, statusMap, props, onCopy, getStatusTextAndClass, copyIcon, SvgIcon, isMobile };
  }
});
export {
  _sfc_main as default
};
